import * as Types from '../../../../../api/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type KnowledgeBaseQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type KnowledgeBaseQuery = { __typename?: 'Query', Profile?: { __typename?: 'Profile', knowledgeBase?: { __typename?: 'KnowledgeBase', _id: string, pinned: Array<{ __typename?: 'KnowledgeBaseArticle', _id: string, articleId: string, categoryId: string, title: Array<{ __typename?: 'LocalizedString', language: string, value: string }>, subtitle?: Array<{ __typename?: 'LocalizedString', language: string, value: string } | null> | null, createdBy: { __typename?: 'MemberUser', _id: string, name?: string | null, lastName: string, firstName: string, logoURL?: string | null }, publishedBy: { __typename?: 'MemberUser', _id: string, name?: string | null, lastName: string, firstName: string, logoURL?: string | null } }> } | null } | null };


export const KnowledgeBaseDocument = gql`
    query knowledgeBase {
  Profile {
    knowledgeBase {
      _id
      pinned {
        _id
        articleId
        categoryId
        title {
          language
          value
        }
        subtitle {
          language
          value
        }
        createdBy {
          _id
          name
          lastName
          firstName
          logoURL
        }
        publishedBy {
          _id
          name
          lastName
          firstName
          logoURL
        }
      }
    }
  }
}
    `;

/**
 * __useKnowledgeBaseQuery__
 *
 * To run a query within a React component, call `useKnowledgeBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useKnowledgeBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKnowledgeBaseQuery({
 *   variables: {
 *   },
 * });
 */
export function useKnowledgeBaseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>(KnowledgeBaseDocument, options);
      }
export function useKnowledgeBaseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>(KnowledgeBaseDocument, options);
        }
export type KnowledgeBaseQueryHookResult = ReturnType<typeof useKnowledgeBaseQuery>;
export type KnowledgeBaseLazyQueryHookResult = ReturnType<typeof useKnowledgeBaseLazyQuery>;
export type KnowledgeBaseQueryResult = ApolloReactCommon.QueryResult<KnowledgeBaseQuery, KnowledgeBaseQueryVariables>;